export const whitelist = [
  '/upm/functionAuth/userAuths',
  '/upm/public/listArea',
  '/upm/region/getUserRegions',
  '/upm/tenant/logout'
]